import React from 'react';
import PropTypes from 'prop-types';
import { cc } from '../../modules/styles';
import './MenuChannel.css';

/**
 * Menu Item for a Channel
 */

const MenuChannel = ({ channel, onNavigation, selected }) => {
  const { name, subreddits } = channel;

  return (
    <button
      className={cc('MenuChannel', selected ? 'MenuChannel--selected' : '')}
      data-title={name}
      onClick={_ => {
        onNavigation(name);
      }}
    >
      <div className="name">{name}</div>

      {subreddits.map(subreddit => (
        <div style={{ marginLeft: '1rem' }} key={subreddit}>
          <div className="MenuChannel__subreddit">{subreddit}</div>
        </div>
      ))}
    </button>
  );
};

export const ChannelPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  subreddits: PropTypes.arrayOf(PropTypes.string).isRequired,
});

MenuChannel.propTypes = {
  channel: ChannelPropTypes.isRequired,
  onNavigation: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

export default MenuChannel;
